<template>
    <button v-bind="$attrs" :type="type" :disabled="loading || disabled">
        <i v-if="loading" class="fas fa-circle-notch fa-spin"></i>
        {{ name }}
    </button>
</template>

<script>
export default {
    name: "SubmitButton",
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        type: {
            type: String,
            default: 'submit'
        },
        name: {
            type: String,
            default: 'Create'
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    }
}
</script>
